import Vue from "vue";
import {
  onChildAdded,
  onChildChanged,
  onChildRemoved
} from "firebase/database";

// import { firebaseAction } from "vuexfire";

import api from "../utils/fbApi";

export default {
  namespaced: true,
  state: {
    currentLantern: {},
    chats: {},
    chatCounts: {},
    users: [],
    savedReplies: [],
    tags: [],
    inboxStarterConfig: {}
  },
  mutations: {
    SET_CHATS: (state, payload) => {
      state.chats = payload.chats;
    },
    APPEND_CHATS: (state, payload) => {
      const currentChatDocs = state.chats.docs;
      const newChatDocs = [...payload.chats.docs, ...currentChatDocs];
      payload.chats.docs = newChatDocs;
      state.chats = payload.chats;
    },
    SET_USERS: (state, payload) => {
      state.users = payload;
    },
    ADD_CHAT: (state, payload) => {
      state.chats.docs.unshift(payload);
    },
    UPDATE_CHAT: (state, payload) => {
      Vue.set(state.chats.docs, payload.index, payload.chat);
    },
    updateChatCount: (state, payload) => {
      Vue.set(state.chatCounts, payload.key, payload.data);
    },
    deleteChatCount: (state, payload) => {
      Vue.delete(state.chatCounts, payload.key);
    },
    SET_SAVED_REPLIES: (state, savedReplies) => {
      state.savedReplies = savedReplies;
    },
    ADD_SAVED_REPLY: (state, savedReply) => {
      state.savedReplies.push(savedReply);
    },
    DELETE_SAVED_REPLY: (state, replyId) => {
      state.savedReplies = state.savedReplies.filter(
        reply => reply.id !== replyId
      );
    },
    SET_TAGS: (state, tags) => {
      state.tags = tags;
    },
    ADD_TAG: (state, tag) => {
      const existingTag = state.tags.find(t => t.id === tag.id);
      if (!existingTag) {
        state.tags.push(tag);
      }
    },
    DELETE_TAG: (state, tagId) => {
      state.tags = state.tags.filter(tag => tag.id !== tagId);
    },
    SET_INBOX_STARTER_CONFIG: (state, config) => {
      state.inboxStarterConfig = config;
    }
  },
  actions: {
    getToken() {
      return api.get(`conversation/token`);
    },
    getHome(context) {
      return api.get(`conversation/home`).then(response => {
        context.commit("SET_USERS", response.users);
      });
    },
    get(context, payload) {
      return api
        .get(
          `conversation/list/?page=${payload.page}&status=${payload.status}&tag=${payload.tag}`
        )
        .then(response => {
          if (payload.page == "1") {
            context.commit("SET_CHATS", {
              chats: response.chats
            });
          } else {
            context.commit("APPEND_CHATS", {
              chats: response.chats
            });
          }

          return response.chats;
        })
        .catch(error => console.log(error));
    },
    getChat(context, payload) {
      return api
        .get(`conversation/get/${payload.conversationId}`)
        .then(response => response.chat);
    },
    getThreads(context, payload) {
      return api
        .get(
          `conversation/threads/${payload.conversationId}?page=${payload.page}`
        )
        .then(response => response.threads);
    },
    sendChat(context, payload) {
      return api.post(
        `conversation/get/${payload.conversationId}`,
        payload.requestParams
      );
    },
    acceptChat(context, payload) {
      return api.post(`conversation/accept/${payload.conversationId}`);
    },
    getNextChat(context, payload) {
      return api.get(`conversation/next/${payload.conversationId}`);
    },
    getPreviousChat(context, payload) {
      return api.get(`conversation/prev/${payload.conversationId}`);
    },
    getCustomer(context, payload) {
      return api.get(`conversation/customer?phone=${payload.phoneNumber}`);
    },
    getNotificationSettings() {
      return api.get(`notification/config`);
    },
    updateNotificationSettings(context, payload) {
      return api.put(`notification/config`, payload.requestParams);
    },
    putAction(context, payload) {
      return api.post(
        `conversation/action/${payload.conversationId}`,
        payload.requestParams
      );
    },
    searchProducts(context, payload) {
      return api.post(`conversation/products`, payload.requestParams);
    },
    updateNotificationToken(context, payload) {
      return api.post(`notification/token`, payload.requestParams);
    },

    getCounts(context, chatCountRef) {
      onChildAdded(chatCountRef, data => {
        const snapshot = data.val();
        const key = data.key;
        context.commit("updateChatCount", { data: snapshot, key });
      });

      onChildChanged(chatCountRef, data => {
        const snapshot = data.val();
        const key = data.key;
        context.commit("updateChatCount", { data: snapshot, key });
      });

      onChildRemoved(chatCountRef, data => {
        const key = data.key;
        context.commit("deleteChatCount", { key });
      });
    },

    getSavedReplies(context) {
      return api.get(`conversation/savedreplies`).then(response => {
        context.commit("SET_SAVED_REPLIES", response.savedReplies);
      });
    },
    createSavedReply(context, payload) {
      return api.post(`conversation/savedreplies`, payload).then(response => {
        context.commit("ADD_SAVED_REPLY", response.savedReply);
      });
    },
    deleteSavedReply(context, replyId) {
      return api.delete(`conversation/savedreplies/${replyId}`).then(() => {
        context.commit("DELETE_SAVED_REPLY", replyId);
      });
    },
    getTags(context) {
      return api.get(`conversation/tags`).then(response => {
        context.commit("SET_TAGS", response.tags);
      });
    },
    createTag(context, payload) {
      return api.post(`conversation/tags`, payload).then(response => {
        context.commit("ADD_TAG", response.tag);
      });
    },
    deleteTag(context, tagId) {
      return api.delete(`conversation/tags/${tagId}`).then(() => {
        context.commit("DELETE_TAG", tagId);
      });
    },
    removeTagFromConversations(context, requestParams) {
      return api.post(`conversation/tags/remove`, requestParams);
    },
    sendTemplateMessage(context, payload) {
      return api.post(`conversation/template`, payload.requestParams);
    },
    getTemplateMessage(context) {
      return api.get(`conversation/template`).then(response => {
        context.commit("SET_INBOX_STARTER_CONFIG", response);
      });
    }
  },
  getters: {
    getChats: state => state.chats,
    getChatCounts: state => state.chatCounts || {},
    getUsers: state => state.users,
    getUserNameById: state => id => {
      const existingUser = state.users.find(user => user.id === id);
      if (existingUser) {
        if (existingUser.lastName) {
          return `${existingUser.firstName} ${existingUser.lastName}`;
        }
        return existingUser.firstName;
      }
      return "Anyone";
    },
    getSavedReplies: state => state.savedReplies,
    getTags: state => state.tags,
    getInboxStarterConfig: state => state.inboxStarterConfig,
    getTagNameById: state => id => {
      const tag = state.tags.find(tag => tag.id === id);
      return tag ? tag.name : "No Tag";
    }
  }
};
